import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { parsePrice, PriceFormats } from "@repo/utils";
import { MAX_VALUES } from "@utils";
import {
  useEstimateEditorSettings,
  useEstimateStructure,
  useSummaryUnitCostInputTooltipAlert,
  ValueCell,
} from "@tools";

export const CompanyUnitCostCell = observer(({
  element,
  displayCellContent,
  useCompanyCurrency,
  ...props
}) => {
  const { allowEdition, useProfitability } = useEstimateEditorSettings();
  const structure = useEstimateStructure();
  const tooltip = useSummaryUnitCostInputTooltipAlert(useProfitability, element.hasFixedPrice);
  
  const {
    currencyObj,
    companyCurrencyObj,
    modifier,
    timeModifier,
    exchangeRateModifier,
    priceFormat
  } = structure.settings;
  
  const {
    hasResources,
    hasFixedPrice,
    displayCompanyUnitCost,
    displayCompanyUnitCostWithModifier,
  } = element;
  
  const usedCurrency = useCompanyCurrency
    ? companyCurrencyObj
    : currencyObj;
  
  const displayValue = useCompanyCurrency
    ? displayCompanyUnitCost
    : displayCompanyUnitCostWithModifier;
  
  const handleCompanyUnitCostChange = (unitCost) => {
    element.setCompanyUnitCost(unitCost / modifier / (useCompanyCurrency ? 1 : exchangeRateModifier));
  };
  
  return (
    <ValueCell
      size="large"
      fullWidthInputs
      emptyInputs={hasFixedPrice}
      displayContent={displayCellContent}
      value={displayValue}
      onValueChange={handleCompanyUnitCostChange}
      editable={!hasResources && allowEdition}
      max={timeModifier === 1 ? MAX_VALUES.RATE_HOUR : MAX_VALUES.RATE_DAY}
      symbolStart={usedCurrency.symbolStart}
      symbolEnd={usedCurrency.symbolEnd}
      americanFormat={priceFormat === PriceFormats.AMERICAN}
      showDecimals
      parser={parsePrice}
      inputClassName="input-unit-cost"
      applySuffixSpacing
      { ...props }
      { ...tooltip }
    />
  );
});

CompanyUnitCostCell.propTypes = {
  element: object.isRequired,
  displayCellContent: bool,
  useCompanyCurrency: bool,
  extendPadding: bool,
};
